<script setup lang="ts">
import ArrowLeftIcon from '@/assets/icons/ArrowLeftIcon.vue';
import ArrowRightIcon from '@/assets/icons/ArrowRightIcon.vue';
import SidebarIcon from '@/assets/icons/SidebarIcon.vue';
import { useTemplateRef } from 'vue';

defineProps<{
  label: string;
  nextLabel: string;
  openLabel: string;
  previousLabel: string;
}>();

const emit = defineEmits<{
  next: [];
  open: [];
  previous: [];
}>();

const openButtonRef = useTemplateRef<HTMLButtonElement>('openButtonRef');

const focusOpenButton = (): void => {
  openButtonRef.value?.focus();
};

defineExpose({ focusOpenButton });
</script>

<template>
  <div class="flex h-[60px] items-center gap-sm bg-highlight px-md py-sm text-tint">
    <button
      ref="openButtonRef"
      type="button"
      class="flex size-button shrink-0 items-center justify-center rounded-button outline-inner state-effects"
      :aria-label="openLabel"
      @click="emit('open')"
    >
      <SidebarIcon class="size-icon" aria-hidden="true" />
    </button>

    <span class="min-w-0 flex-1 truncate text-body font-semibold leading-[1.7]">
      {{ label }}
    </span>

    <div class="flex shrink-0 items-center">
      <button
        type="button"
        class="flex size-button items-center justify-center rounded-button outline-inner state-effects"
        :aria-label="previousLabel"
        @click="emit('previous')"
      >
        <ArrowLeftIcon class="size-icon" aria-hidden="true" />
      </button>
      <button
        type="button"
        class="flex size-button items-center justify-center rounded-button outline-inner state-effects"
        :aria-label="nextLabel"
        @click="emit('next')"
      >
        <ArrowRightIcon class="size-icon" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>
